import { render, staticRenderFns } from "./ConfirmationCodeForm.vue?vue&type=template&id=2acdc67f&scoped=true&"
import script from "./ConfirmationCodeForm.vue?vue&type=script&lang=ts&"
export * from "./ConfirmationCodeForm.vue?vue&type=script&lang=ts&"
import style0 from "./ConfirmationCodeForm.vue?vue&type=style&index=0&id=2acdc67f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2acdc67f",
  null
  
)

export default component.exports